<template>
  <div class="tw-text-sf-gray-dark tw-text-sm tw-leading-[18px] tw-font-medium">
    {{ errorTitle }}
  </div>
  <div class="tw-text-sf-gray-light tw-text-sm tw-leading-[18px] tw-mb-2">
    {{ subtitle }}
  </div>
  <div :class="mainErrorContainerClasses">
    <div v-for="id in erroredOutDocumentIds" :key="id" class="tw-mb-2">
      <DocumentCard
        :allow-delete="false"
        :allow-download="false"
        :document="documents[id]"
        :variant="ColorVariants.DANGER"
        :error-messages="errorsPerDocument[id]"
      />
    </div>
  </div>
  <div v-if="isPartialError">
    <div
      class="
        tw-text-sf-gray-dark tw-text-sm tw-leading-[18px] tw-font-medium tw-mb-2
      "
    >
      {{ continueText }}
    </div>
    <div v-for="id in successfulDocumentsIds" :key="id" class="tw-mb-2">
      <DocumentCard
        :allow-delete="false"
        :allow-download="false"
        :document="documents[id]"
        :variant="ColorVariants.SUCCESS"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { UIState } from '../types'

import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { ColorVariants } from '@app/shared/constants'
import useI18n from '@app/shared/vue/composables/use-I18n'
import DocumentCard from './document-card.vue'

import { useOCRDocuments } from '../store/use-ocr-documents'
import { useOCRUI } from '../store/use-ocr-ui'

const I18n = useI18n()

const uiStore = useOCRUI()
const { uiState } = storeToRefs(uiStore)

const documentStore = useOCRDocuments()
const { allDocumentsErroredOut, documents, errorsPerDocument } =
  storeToRefs(documentStore)

const isPartialError = computed(
  () => uiState.value === UIState.PartialError && !allDocumentsErroredOut.value
)

const errorTitle = I18n.t('ai_ocr_requests.steps.messages.failed_title')
const subtitle = computed(() => {
  if (isPartialError.value) {
    return I18n.t('ai_ocr_requests.steps.messages.failed_partial_description')
  }

  return I18n.t('ai_ocr_requests.steps.messages.failed_description')
})

const mainErrorContainerClasses = computed(() => {
  return {
    'tw-mb-12': isPartialError.value,
  }
})

const erroredOutDocumentIds = computed(() => {
  if (uiState.value === UIState.Error) {
    return Object.keys(documents.value)
  }

  return Object.keys(errorsPerDocument.value)
})

const continueText = I18n.t('ai_ocr_requests.steps.messages.continue')

const successfulDocumentsIds = computed(() => {
  if (uiState.value === UIState.Error) {
    return []
  }

  return Object.keys(documents.value).filter(
    (id) => !errorsPerDocument.value[id]
  )
})
</script>
